import {createSlice } from '@reduxjs/toolkit'

const CitySlice = createSlice({
    name: "CitySlice",
    initialState: {
        SelectedCity: {
            id: 0,
            City: '',
            Adress: ''
        },
        CityArray: [],
        CityArrayReport: [],
        UniqueCityArray: []
    },
    reducers: {
        CityArrayAdd(state, actions){            
            const SortData = actions.payload.sort((a , b) => {
                return a.City === b.City ? a.Adress > b.Adress ? 1 : -1 : a.City > b.City ? 1 : -1            
            })
            state.CityArray = SortData
        },
        addCityArrayReport(state){
            let CityCheck = []
            state.CityArray.map((el) => {
                return(CityCheck.push(
                    {
                        id: el.id, 
                        City: el.City, 
                        Adress: el.Adress,                      
                        VisibleReport: true, 
                        OpenIncomeArticlesCash: false, 
                        OpenExpenditureArticlesCash: false, 
                        OpenIncomeArticlesNonCash: false,                     
                        OpenExpenditureArticlesNonCash: false,
                        OpenIncomeArticlesResult: false, 
                        OpenExpenditureArticlesResult: false,
                        OpenBackgroundInformation: false,
                        DirectorID: el.DirectorID
                    }
                ))
            })
            state.CityArrayReport = CityCheck
        },
        CityFromAddUserAdd(state){
            state.CityArray.map((el) => {
                el.AddedUser = false
                el.ResponsibleUser = false
                return(el)
            })
        },
        changeCityArrayAddedUser(state, actions){
            state.CityArray.map((el) => {
                if(el.id === actions.payload)
                {
                    if(el.AddedUser)
                        el.ResponsibleUser = false
                    el.AddedUser = !el.AddedUser
                }
                return(el)
            })
        },
        changeCityArrayResponsibleUser(state, actions){
            state.CityArray.map((el) => {
                if(el.id === actions.payload)
                {
                    el.ResponsibleUser = !el.ResponsibleUser
                }
                return(el)
            })
        },
        CityAddRevenue(state, actions){
            state.CityArray.map((el) => {
                if(el.id === actions.payload.idCity)
                {
                    el.idRevenue = actions.payload.idRevenue
                    el.Revenue = actions.payload.Revenue
                    el.Percent = actions.payload.Percent
                }
                return(el)
            })
            if(state.SelectedCity.id === actions.payload.idCity)
            {
                state.SelectedCity.idRevenue = actions.payload.idRevenue
                state.SelectedCity.Revenue = actions.payload.Revenue
                state.SelectedCity.Percent = actions.payload.Percent
            }
        },
        SelectCity(state, actions){
            state.SelectedCity = {
                id: 0,
                City: '',
                Adress: ''
            }
                state.SelectedCity = actions.payload
        },
        ClearSelectedCity(state){
            state.SelectedCity = {
                id: 0,
                City: '',
                Adress: ''
            }
        },
        EditUserAddCity(state, actions){
            state.CityArray.map((el) => {
                if(el.id === actions.payload)
                {
                    el.AddedUser = true
                }
                return(el)
            })
        },
        EditUserAddResponsibleUser(state, actions){
            state.CityArray.map((el) => {
                if(el.id === actions.payload)
                {
                    el.ResponsibleUser = true
                }
                return(el)
            })
        },
        changeCityArrayReportOpenInf(state, actions){            
            switch(actions.payload.Type){
                case('income Cash'):{
                    state.CityArrayReport.find((el) => el.id === actions.payload.id).OpenIncomeArticlesCash = !state.CityArrayReport.find((el) => el.id === actions.payload.id).OpenIncomeArticlesCash
                    break
                }
                case('expenditure Cash'):{
                    state.CityArrayReport.find((el) => el.id === actions.payload.id).OpenExpenditureArticlesCash = !state.CityArrayReport.find((el) => el.id === actions.payload.id).OpenExpenditureArticlesCash
                    break
                }
                case('income NonCash'):{
                    state.CityArrayReport.find((el) => el.id === actions.payload.id).OpenIncomeArticlesNonCash = !state.CityArrayReport.find((el) => el.id === actions.payload.id).OpenIncomeArticlesNonCash
                    break
                }
                case('expenditure NonCash'):{
                    state.CityArrayReport.find((el) => el.id === actions.payload.id).OpenExpenditureArticlesNonCash = !state.CityArrayReport.find((el) => el.id === actions.payload.id).OpenExpenditureArticlesNonCash
                    break
                }
                case('income Result'):{
                    state.CityArrayReport.find((el) => el.id === actions.payload.id).OpenIncomeArticlesResult = !state.CityArrayReport.find((el) => el.id === actions.payload.id).OpenIncomeArticlesResult
                    break
                }
                case('expenditure Result'):{
                    state.CityArrayReport.find((el) => el.id === actions.payload.id).OpenExpenditureArticlesResult = !state.CityArrayReport.find((el) => el.id === actions.payload.id).OpenExpenditureArticlesResult
                    break
                }
                case('BackgroundInformation'):{
                    state.CityArrayReport.find((el) => el.id === actions.payload.id).OpenBackgroundInformation = !state.CityArrayReport.find((el) => el.id === actions.payload.id).OpenBackgroundInformation
                    break
                }
                default:{
                    break
                }
            }
            
        },
        getUniqueCity(state){
            const uniqueCities = state.CityArray.reduce((acc, el) => {
                if (!acc.includes(el.City)) {
                  acc.push(el.City)
                }
                return acc;
            }, [])

            let CityCheck = []
            
            uniqueCities.map((el) => {
                let QuantityBranch = []
                QuantityBranch = state.CityArray.filter((a) => a.City === el)

                if(QuantityBranch.length > 1)
                    return(CityCheck.push(
                        {
                            City: el, 
                            VisibleReportCity: true, 
                            ManyBranches: true
                        }
                    ))

                    return(CityCheck.push(
                        {
                            City: el + ' ' + QuantityBranch[0].Adress, 
                            VisibleReportCity: true, 
                            ManyBranches: false
                        }
                    ))
            })

            state.UniqueCityArray = CityCheck
        },
        changeVisibleReportOneBranch(state, actions){
            state.CityArrayReport.map((el) => {
                if(el.id === actions.payload) 
                    el.VisibleReport = !el.VisibleReport
                return(el)
            })
            
            state.UniqueCityArray.map((el) => 
            {
                if(el.ManyBranches)
                {
                    let indeterminateCheck = state.CityArrayReport.filter((a) => (a.City === el.City && a.VisibleReport)).length

                    if(indeterminateCheck === 0)                
                        return(el.VisibleReportCity = false)
                    
                    if(indeterminateCheck > 0 && indeterminateCheck < state.CityArrayReport.filter((a) => a.City === el.City).length)
                        return(el.VisibleReportCity = 'indeterminate')

                    return(el.VisibleReportCity = true)
                }
            })
        },
        changeVisibleReportOneCity(state, actions){
            state.UniqueCityArray.map((el) => 
            {
                if(el.City === actions.payload)
                {
                    if(el.VisibleReportCity === true || el.VisibleReportCity === 'indeterminate')
                    {
                        if(el.ManyBranches)
                        {
                            state.CityArrayReport.filter((a) => a.City === el.City).map((item) => {
                                item.VisibleReport = false
                                return item;
                            })
                        }
                        else
                        {
                            state.CityArrayReport.filter((a) => (a.City + ' ' + a.Adress)=== el.City).map((item) => {
                                item.VisibleReport = false
                                return item;
                            })
                        }
                    }
                    else
                    {
                        if(el.ManyBranches)
                            {
                                state.CityArrayReport.filter((a) => a.City === el.City).map((item) => {
                                    item.VisibleReport = true
                                    return item;
                                })
                            }
                            else
                            {
                                state.CityArrayReport.filter((a) => (a.City + ' ' + a.Adress)=== el.City).map((item) => {
                                    item.VisibleReport = true
                                    return item;
                                })
                            }
                    }

                    el.VisibleReportCity = !el.VisibleReportCity
                }
                return(el)
            })
        },
        changeVisibleReportAllCity(state, actions){
            state.UniqueCityArray.map((el) => {
                return(el.VisibleReportCity = actions.payload)
            })

            state.CityArrayReport.map((el) => {
                return(el.VisibleReport = actions.payload)
            })
        },
        changeDirector(state, actions){
            state.CityArrayReport.find((el) => el.id === actions.payload.idCity).DirectorID = actions.payload.DirectorID
            state.CityArray.find((el) => el.id === actions.payload.idCity).DirectorID = actions.payload.DirectorID
        }
    }
})

export default CitySlice.reducer
export const { 
    CityArrayAdd,  
    SelectCity, 
    ClearSelectedCity, 
    CityAddRevenue, 
    CityFromAddUserAdd, 
    changeCityArrayAddedUser, 
    changeCityArrayResponsibleUser, 
    EditUserAddCity,
    EditUserAddResponsibleUser,
    addCityArrayReport,
    changeCityArrayReportOpenInf,
    getUniqueCity,
    changeVisibleReportOneBranch,
    changeVisibleReportOneCity,
    changeVisibleReportAllCity,
    changeDirector
} = CitySlice.actions